import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import { Socials } from "../components/Home/Socials";
import { Box } from "@mui/material";
import { ReactComponent as WhatsappIcon } from "../static/svg/socials/whatsapp.svg";
import { ContactBody } from "../components/Contact/ContactBody";

export const Contact = () => {
  let userNumber = 447936794742;

  return (
    <React.Fragment>
      {/* <MainHeader name={"Contact"} /> */}
      <ContactBody />
      <Box>
        <a
          href={`https://wa.me/${userNumber}?text=Hello%20*StrandzByDee*%0A`}
          class="whatsapp_float"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsappIcon className=" h-10 md:h-[60px] w-10 md:w-[60px]" />
          {/* <img
            width="240"
            height="240"
            src="https://img.icons8.com/color/240/whatsapp--v1.png"
            alt="whatsapp--v1"
          /> */}
        </a>
      </Box>

      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};
